// Shared base classes for loading skeleton placeholders across the build view
// (step list rows, step drawer, etc.) so they animate and shade consistently.
// Compose with element-specific classes (sizing, layout) via classNames/twMerge.
export const SKELETON_PULSE = "animate-pulse rounded-sm bg-gray-200 dark:bg-charcoal-800";
